import { render, staticRenderFns } from "./AppointmentSettingsTab.vue?vue&type=template&id=42f4e0cc&scoped=true&"
import script from "./AppointmentSettingsTab.vue?vue&type=script&lang=js&"
export * from "./AppointmentSettingsTab.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentSettingsTab.vue?vue&type=style&index=0&id=42f4e0cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f4e0cc",
  null
  
)

export default component.exports